import { render, staticRenderFns } from "./OddsRow.vue?vue&type=template&id=dd1e7d8a&"
import script from "./OddsRow.vue?vue&type=script&lang=js&"
export * from "./OddsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports